/* @flow */

import { DateTime } from 'luxon';
import { TAG_TYPE } from 'src/shared/app/base/api/apiConstant';
import { getTopicId } from '@braindate/domain/lib/topic/util';

import { infiniteLoadingSettings } from 'src/shared/app/base/api/utils/endpointUtils';
import {
  topicEndpoint,
  topicsEndpoint,
} from 'src/shared/app/base/settings/endpointSettings';
import { apiRoot } from 'src/shared/app/base/api/apiRoot';
import type { Topic } from '@braindate/domain/lib/topic/type';
import type {
  UseQuery,
  ApiListResult,
} from 'src/shared/app/base/api/type/apiQueryType';
import { defaultLimitPages } from 'src/shared/app/base/api/constant/apiConstant';

type Api = {
  useGetTopicsByAuthorLiveQuery: UseQuery<ApiListResult<Topic>>,
  useGetTopicsByAuthorPastQuery: UseQuery<ApiListResult<Topic>>,
  useGetTopicQuery: UseQuery<Topic>,
};

const extendedApi: Api = apiRoot.injectEndpoints({
  endpoints: (builder) => ({
    getTopic: builder.query({
      query: ({ id }) => ({
        url: topicEndpoint(id),
      }),
      providesTags: (result, _, { id }) => [{ type: TAG_TYPE.TOPIC, id }],
    }),
    getTopicsByAuthorLive: builder.query({
      query: ({ id, page = 1 }) => ({
        url: topicsEndpoint(),
        params: {
          past: false,
          author_id: id,
          limit: defaultLimitPages,
          offset: (page - 1) * defaultLimitPages,
        },
      }),
      ...infiniteLoadingSettings<Topic>({
        tagType: TAG_TYPE.TOPIC,
        idGetter: getTopicId,
      }),
    }),
    getTopicsByAuthorPast: builder.query({
      query: ({ id, page = 1 }) => ({
        url: topicsEndpoint(),
        params: {
          end_time_before: DateTime.now().toISO(),
          author_id: id,
          limit: defaultLimitPages,
          offset: (page - 1) * defaultLimitPages,
        },
      }),
      ...infiniteLoadingSettings<Topic>({
        tagType: TAG_TYPE.TOPIC,
        idGetter: getTopicId,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTopicQuery,
  useGetTopicsByAuthorLiveQuery,
  useGetTopicsByAuthorPastQuery,
} = extendedApi;
